import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { SubmitMortgageSign, fetchInitialState, updateMortgageSignOption, updateMortgageLogoOption } from './mortgageSignSlice';
// import RizeSignImage from '../../img/Rize-Mortgage_Icon.png'
import { BACKEND_API_URL } from '../../config';
import Loader from '../../components/loader';
import { OptionCard, OptionCardRow, StepHeading, StepShell } from '../../components/optionCard';

const CircularProgress = ({ progress }) => {
    return (

      <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex justify-center items-center">
        <svg className="w-20 h-20 transform -rotate-90" viewBox="0 0 100 100">
          <circle
            cx="50"
            cy="50"
            r="45"
            stroke="currentColor"
            strokeWidth="10"
            fill="transparent"
            className="text-gray-300"
          />
          <circle
            cx="50"
            cy="50"
            r="45"
            stroke="currentColor"
            strokeWidth="10"
            fill="transparent"
            strokeDasharray="283"
            strokeDashoffset={283 - (283 * progress) / 100}
            className="text-custom-orange"
            style={{ transition: 'stroke-dashoffset 0.5s ease' }}
          />
        </svg>
        <div className="absolute flex items-center justify-center text-custom-purple text-xl font-semibold">
          {progress}%
        </div>
      </div>
    );
  };

const MortgageSign = () => {
    const mortgageSignState = useSelector(state => state.mortgage_sign);
    const [downloadProgress, setDownloadProgress] = useState(0);
    const [isLoading, setIsLoading] = useState(false);

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(fetchInitialState())
    }, [dispatch])

    const handleFileChange = (e) => {
        if (e.target.files && e.target.files.length > 0) {
            // Handle file selection via input
            let uploadedFile = e.target.files[0];
            dispatch(SubmitMortgageSign({ ...mortgageSignState.data, '_image': uploadedFile}));

        } else if (e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files.length > 0) {
            // Handle file drop
            let uploadedFile = e.dataTransfer.files[0];
            dispatch(SubmitMortgageSign({ ...mortgageSignState.data, '_image': uploadedFile}));
        }
        e.target.value = null;
    }

    const handleDelete = (e) => {
        e.preventDefault()
        dispatch(SubmitMortgageSign({ ...mortgageSignState.data, '_image': 'delete' }))
    
      };
    
    const handleDownload = (e) => {
      e.preventDefault()
      const url = `${BACKEND_API_URL}/api/files/download?path=${encodeURIComponent(mortgageSignState.data._image)}`;
        fetch(url)
          .then(response => response.blob())
          .then(blob => {
              const url = window.URL.createObjectURL(blob);
              const a = document.createElement('a');
              a.style.display = 'none';
              a.href = url;
              // Specify a filename for the downloaded file
              a.download = mortgageSignState.data._image.split("/").pop();
              document.body.appendChild(a);
              a.click();
              window.URL.revokeObjectURL(url);
          })
          .catch(err => console.error('Fetch error:', err));
    };


    const downloadLogoFile = async () => {
        try {
            setIsLoading(true);
            const response = await fetch(`${BACKEND_API_URL}/api/rize-logo-package`, {
                method: 'GET',
            });
        
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }

            const contentLength = response.headers.get('Content-Length');
            if (!contentLength) {
                throw new Error('Content-Length header is missing');
            }

            const totalBytes = parseInt(contentLength, 10);
            let receivedBytes = 0;
            const reader = response.body.getReader();
            const stream = new ReadableStream({
                async start(controller) {
                    while (true) {
                        const { done, value } = await reader.read();
                        if (done) break;

                        receivedBytes += value.length;
                        setDownloadProgress(Math.round((receivedBytes / totalBytes) * 100));

                        controller.enqueue(value);
                    }
                    controller.close();
                    reader.releaseLock();
                },
            });
        
            const blob = await new Response(stream).blob();
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = 'Rize-Mortgage-Logo-Package.zip';
            document.body.appendChild(a); // Append to the body
            a.click();
            a.remove(); 
        } catch (error) {
            console.error('There was an error downloading the file:', error);
        } finally {
            setIsLoading(false); // Stop loading
            setDownloadProgress(0); // Reset progress
        }
    };


    return (
    <>
        { mortgageSignState.loading && <Loader /> }
        { isLoading && <CircularProgress progress={downloadProgress} /> }
        <StepShell>
            <StepHeading>
                Do you have a Rize Mortgage Sign for your office?
            </StepHeading>
            <OptionCardRow>
                {/* Yes Option */}
                <OptionCard
                    selected={mortgageSignState.data.sign_option === 'Yes'}
                    onClick={() => dispatch(updateMortgageSignOption('Yes'))}
                >
                    Yes
                </OptionCard>

                {/* No Option */}
                <OptionCard
                    selected={mortgageSignState.data.sign_option === 'No'}
                    onClick={() => dispatch(updateMortgageSignOption('No'))}
                >
                    No
                </OptionCard>

                {/* ORDERED Option */}
                <OptionCard
                    selected={mortgageSignState.data.sign_option === 'Ordered'}
                    onClick={() => dispatch(updateMortgageSignOption('Ordered'))}
                >
                    Ordered
                </OptionCard>
            </OptionCardRow>

            { mortgageSignState.data.sign_option === 'Yes' && ((mortgageSignState.data._image && mortgageSignState.data._image !== 'null') ? (
                                <div className="mb-4 mt-10 grid w-full max-w-md grid-cols-3 items-center justify-between gap-2 rounded-xl border border-slate-200 bg-white p-4 shadow-sm">
                                        <p className="col-span-2 truncate text-sm font-semibold text-[#211b4f]">
                                            {mortgageSignState.data._image.split("/").pop()}
                                        </p>
                                        <div className="col-span-1 flex justify-end">
                                            <button
                                                onClick={handleDownload}
                                                className="inline-flex h-9 w-9 items-center justify-center rounded-lg fill-current text-[#211b4f] transition-colors hover:bg-[#211b4f]/5"
                                            >
                                                {/* <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-down-circle" viewBox="0 0 16 16">
                                                    <path fillRule="evenodd" d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8m15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0M8.5 4.5a.5.5 0 0 0-1 0v5.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293z"/>
                                                </svg> */}
                                                <svg xmlns="http://www.w3.org/2000/svg" height="26" viewBox="0 0 24 24" width="26">
                                                    <path d="M0 0h24v24H0z" fill="none"/>
                                                    <path d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z"/>
                                                </svg>
                                            </button>
                                            <button
                                                onClick={handleDelete}
                                                className="inline-flex h-9 w-9 items-center justify-center rounded-lg text-red-600 transition-colors hover:bg-red-50"
                                            >
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-trash" viewBox="0 0 16 16">
                                                    <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z"/>
                                                    <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z"/>
                                                </svg>
                                            </button>
                                    </div>
                                </div>
                            ) : (
                                <div className="mt-10 flex w-full max-w-md items-center justify-center"
                                    onDragOver={(e) => {e.preventDefault(); e.stopPropagation()}}
                                    onDragEnter={(e) => {e.preventDefault(); e.stopPropagation()}}
                                    onDragLeave={(e) => {e.preventDefault(); e.stopPropagation()}}
                                    onDrop={(e) => { e.preventDefault(); e.stopPropagation(); handleFileChange(e)}}
                                    >
                                    <label htmlFor="dropzone_file" className="flex flex-col items-center justify-center w-full  border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50  hover:bg-gray-100">
                                        <div className="flex flex-col items-center justify-center pt-5 pb-6">
                                            <svg className="w-8 h-8 mb-4 text-gray-500 " aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 16">
                                                <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2"/>
                                            </svg>
                                            <p className="mb-2 text-sm text-gray-500 "><span className="font-semibold">Click to upload Picture of your Sign</span> </p>
                                            <p className="mb-2 text-sm text-gray-500 ">or drag and drop</p>
                                        </div>
                                        <input name='_image' onChange={handleFileChange} id="dropzone_file" type="file" className="hidden" />
                                    </label>
                                </div> 
                            ))
            }

            {mortgageSignState.data.sign_option === 'No' && (
                <h3 className="mt-6 text-center text-base font-normal text-slate-500 sm:text-xl">
                    We recommend that you contact a local sign provider or the landlord if they provide the signage.
                </h3>
            )}

            {/* 2nd Question */}
            {mortgageSignState.data.sign_option === 'No' && (
                <>
                    <StepHeading className="mt-12 sm:mt-14">
                        Do you need the Rize Logo for your sign provider?
                    </StepHeading>

                    <OptionCardRow>
                        {/* Yes Option */}
                        <OptionCard
                            selected={mortgageSignState.data.logo_option === 'Yes'}
                            onClick={() => dispatch(updateMortgageLogoOption('Yes'))}
                        >
                            Yes
                        </OptionCard>

                        {/* No Option */}
                        <OptionCard
                            selected={mortgageSignState.data.logo_option === 'No'}
                            onClick={() => dispatch(updateMortgageLogoOption('No'))}
                        >
                            No
                        </OptionCard>
                    </OptionCardRow>

                {mortgageSignState.data.logo_option === 'Yes' && (
                    // <a href={RizeSignImage} download="Rize-Mortgage-Logo" className="mt-6 text-base font-medium text-[#fb6635] underline decoration-orange-200 underline-offset-2 hover:decoration-[#fb6635] sm:text-lg">
                    //     Click to download Rize Logo.
                    // </a>
                    <button onClick={downloadLogoFile} className="mt-6 text-base font-medium text-[#fb6635] underline decoration-orange-200 underline-offset-2 hover:decoration-[#fb6635] sm:text-lg">
                        Click to download Rize Logo.
                    </button>
                )}
                </>
    
            )}

            
            {/* <img className={`${mortgageSignState.data.sign_option === 'Yes' ? 'mt-10' : 'mt-14'} mb-4`} src={RizeSignImage} height={200} alt='file cabinet'/> */}
        </StepShell>

    </>
  )
}

export default MortgageSign;
